// Centralized business information constants
// Update these values in one place to change across the entire app

export const BUSINESS_PHONE = "504-305-4430";
export const BUSINESS_PHONE_FORMATTED = "(504) 305-4430";
export const BUSINESS_PHONE_LINK = "tel:504-305-4430";

export const BUSINESS_EMAIL = "jason@nolabeds.com";
export const BUSINESS_EMAIL_SUBJECT = "New%20Question%20for%20Beds%204%20Less";
export const BUSINESS_EMAIL_LINK = `mailto:${BUSINESS_EMAIL}?subject=${BUSINESS_EMAIL_SUBJECT}`;

export const BUSINESS_ADDRESS = "3729 Williams Blvd";
export const BUSINESS_ADDRESS_FULL = "3729 Williams Blvd • Kenner";
export const BUSINESS_ADDRESS_NOTE = "2 blocks from W. Esplanade";

export const GOOGLE_MAPS_URL = "https://www.google.com/maps/place/Beds+4+Less/@30.0244693,-90.2414124,17z/data=!3m1!4b1!4m5!3m4!1s0x8620b6deb85da38d:0xb1330ab9517646aa!8m2!3d30.0244693!4d-90.2392237";
export const APPLE_MAPS_URL = "maps://www.google.com/maps/place/Beds+4+Less/@30.0244693,-90.2414124,17z/data=!3m1!4b1!4m5!3m4!1s0x8620b6deb85da38d:0xb1330ab9517646aa!8m2!3d30.0244693!4d-90.2392237";

export const SOCIAL_LINKS = {
    facebook: "https://www.facebook.com/Beds4Less",
    yelp: "https://www.yelp.com/biz/beds-4-less-kenner"
};

export const SNAP_FINANCING_URL = "https://consumer.snapfinance.com/#/?mid=37257";

// Business hours configuration
export const BUSINESS_HOURS = {
    open: { start: "10a", end: "6p", display: "10 a.m. – 6 p.m." },
    openDays: [2, 3, 4, 5, 6], // Tuesday through Saturday (0=Sunday)
    closedDays: [0, 1], // Sunday and Monday
    closedDisplay: "Closed"
};

// Day names for display
export const DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
